import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c9245b52"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "flex align-content-end flex-wrap",
  style: {"height":"70%"}
}
const _hoisted_2 = { class: "flex align-items-center justify-content-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", { class: "text-3xl" }, "MULAI", -1))

export function render(_ctx, _cache) {
  const _component_p_button = _resolveComponent("p-button")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.showGif ? 'background-depan' : 'background-depan-end'])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_p_button, {
          severity: "danger",
          rounded: "",
          onClick: _cache[0] || (_cache[0] = $event => (_ctx.$router.push('/home')))
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        })
      ])
    ])
  ], 2))
}